export const CHANGEBOT = 'CHANGEBOT'
export const CHANGEMSGREPLY = 'CHANGEMSGREPLY'
export const CHANGEREPLY = 'CHANGEREPLY'
export const CHANGEFRIEND = 'CHANGEFRIEND'
export const MYPROFILE = 'MYPROFILE'
export const SHOWMEMBER = 'SHOWMEMBER'
export const MYNAME = 'MYNAME'
export const CHANGEGROUP = 'CHANGEGROUP'
export const CHANGEGROUPMEMBER = 'CHANGEGROUPMEMBER'
export const CHANGERIGHTTOOL = 'CHANGERIGHTTOOL'
export const SENDREQUEST = 'SENDREQUEST'
export const LISTSENDREQUEST = 'LISTSENDREQUEST'
export const REQUEST = 'REQUEST'
export const LISTREQUEST = 'LISTREQUEST'
export const LISTFRIEND = 'LISTFRIEND'
export const LISTCHAT = 'LISTCHAT'
export const CHATFILE = 'CHATFILE'
export const CHATIMAGE = 'CHATIMAGE'
export const GROUPREQ = 'GROUPREQ'
export const LISTGROUPREQ = 'LISTGROUPREQ'
export const LISTGROUP = 'LISTGROUP'
export const TOKENROOM = 'TOKENROOM'
export const GROUPIDREMOVE = 'GROUPIDREMOVE'
export const LISTBOT = 'LISTBOT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js